module.exports = __webpack_public_path__ + "a673d13dae65573e1610266f45ff1f41.svg";